import { render, staticRenderFns } from "./pipeline_failed_jobs_widget.vue?vue&type=template&id=61015353"
import script from "./pipeline_failed_jobs_widget.vue?vue&type=script&lang=js"
export * from "./pipeline_failed_jobs_widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports